import { render, staticRenderFns } from "./ReviewFormConfirmation.vue?vue&type=template&id=01ab2e2a&"
import script from "./ReviewFormConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReviewFormConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReviewFormConfirmation.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports